module.exports = __webpack_public_path__ + "img/logo_nomal.aab861dd.png";